import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHash = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M4 9H20M4 15H20M10 3L8 21M16 3L14 21",
		stroke: "black",
		strokeOpacity: .87,
		strokeWidth: 2,
		strokeLinecap: "round",
		fill: "none",
		fillOpacity: .88,
		strokeLinejoin: "round"
	})]
});
const ForwardRef = forwardRef(SvgHash);
export { ForwardRef as ReactComponent };
